export const controls = {
  title: 'Zarządzaj kontrolkami',
  description: 'Dodawaj, edytuj, usuwaj kontrolki i zarządzaj ich kolejnością',
  addControl: 'Dodaj kontrolkę',
  deleteTitle: 'Czy na pewno chcesz usunąć kontrolkę: {code}?',
  createdSuccess: 'Kontrolka została utworzona',
  updatedSuccess: 'Kontrolka została zaktualizowana',
  deletedSuccess: 'Kontrolka została usunięta',
  updatedIndexSuccess:
    'Zmiana kolejności wyświetlania kontrolek w konfiguratorze',
  noControls: 'Brak kontrolek',
  showHide: 'pokaż / ukryj',
  heading: 'Sterowanie',
  fields: {
    code: 'Kod',
    label: 'Etykieta',
    type: 'Typ',
    defaultValue: 'Domyślna wartość',
    isDisabled: 'Zablokowana?',
    isVisible: 'Widoczna?',
    isDisabledBadge: 'Zablokowana',
    isVisibleBadge: 'Ukryta',
  },
  types: {
    toggle: 'Przełącznik (tak/nie)',
  },
  tooltip: {
    edit: 'Edytuj',
    delete: 'Usuń',
    move: 'Przeciągnij aby zmienić kolejność wyświetlania w widoku',
    isDisabled:
      'Czy chcesz, aby kontrolka była widoczna, ale niedostępna do wyboru na ekranie konfiguracji?',
    isVisible:
      'Czy chcesz, aby kontrolka była niewidoczna na ekranie konfiguracji?',
  },
} as const
